import { Type, plainToClass } from 'class-transformer'

export class Skill {
  constructor (public name: string, public category?: string) {
    this.name = name;
    this.category = category
  }

  static fromJson (json:any):Skill {
    return  plainToClass(Skill, json);
  }

  toJson ():string {
    return JSON.parse(JSON.stringify(this))
  }
}

export class User {
    public pk?:Number;
    public email: string;
    public password?: string;
    public name: string;
    public surname?: string;
    public description?: string;
    public ubication: string;
    public profesion: string;
    @Type(() => Skill)
    public skills: Array<Skill>;
    public hours_of_work?: Number;
    public experience_in_startups?: boolean;
    public has_project?: boolean;
    public cv_url?: string;
    public promo_code?: string;

    constructor (email: string,
      name: string, ubication: string,
      profesion: string, skills: Array<Skill>,
      surname?: string, description?: string, password?: string, hours_of_work?: Number,
      experience_in_startups?: boolean, has_project?: boolean, cv_url?: string, pk?:Number, promo_code?: string
    ) {
      this.pk = pk;
      this.email = email;
      this.password = password;
      this.name = name;
      this.surname = surname;
      this.description = description;
      this.ubication = ubication;
      this.profesion = profesion;
      this.skills = skills;
      this.hours_of_work = hours_of_work;
      this.experience_in_startups = experience_in_startups;
      this.has_project = has_project;
      this.cv_url = cv_url;
      this.promo_code = promo_code
    }

    static fromJson (json:any):User {
      return plainToClass(User, json);
    }

    toJson ():string {
      return JSON.parse(JSON.stringify(this))
    }
}
